<div class="mat-datepicker-content">
  <mat-calendar
    [selected]="value()"
    [startAt]="startAt()"
    [dateFilter]="dateFilter"
    [headerComponent]="header"
    (selectedChange)="onSelected($event)"
  ></mat-calendar>
</div>
